import { slugify } from '~/assets/js/utils/slug'

// Tags do targeting do ad set institucional.
export const DEFAULT_SLOT_TAGS = ['quero-bolsa', 'graduacao']

// `dimensão:valor`, o mesmo formato das tags de campanha do Montilla
// (`funnel_stage:Topo`, `offer_level:Graduação`). Valor vazio vira `null`.
const buildTag = (dimension, value) => {
  const slug = value ? slugify(String(value)) : ''

  return slug ? `${dimension}:${slug}` : null
}

const withDefaults = tags => [...new Set([...DEFAULT_SLOT_TAGS, ...tags.filter(Boolean)])]

// Contexto da categoria para a segmentação das peças pelo admin.
export function categorySlotTags (category) {
  return withDefaults([buildTag('enem_category', category?.slug)])
}

// Contexto do artigo: categoria, o próprio artigo e os temas dele (as tags do
// CMS, `ManualDoEnemTags`), para segmentar por qualquer um dos três.
export function lessonSlotTags ({ category, lesson } = {}) {
  const topics = (lesson?.tags ?? []).map(tag => buildTag('enem_topic', tag?.ManualDoEnemTags_id?.name))

  return withDefaults([
    buildTag('enem_category', category?.slug),
    buildTag('enem_article', lesson?.slug),
    ...topics,
  ])
}
